<template>
    <wg-image :url="url" :styleObject="Object.assign({type: type}, realStyle)"></wg-image>
</template>
<script>
import Mixin from '../mixin.js';
import Env from 'common/env.js';

export default {
    mixins: [Mixin],
    data () {
        return {
            defaultStyle: {
                width: 48,
                borderRadius: '20%',
                adapt: false,
            },
            type: 'game'
        }
    },
    props: {
        styleObject: {
            type: Object,
            default () {
                return {
                }
            }
        },
        url: {
            type: String,
            default: ''
        }
    },
    computed: {
        realStyle () {
            return Object.assign(this.defaultStyle, (this.styleObject || {}))
        },
        realRatio() {
            return this.realStyle.adapt ? 0.853 : 1
        },
        realWidth () {
            let width;
            if(Env.isCSR) {
                width = Env.getCSR().getSystemInfo().windowWidth;
            }else{
                width = document.documentElement.clientWidth;
            }
            if(width < 360) {
                return this.realStyle.width * this.realRatio
            }
            return this.realStyle.width
        },

        realBorderRadius () {
            return ('' + this.realStyle.borderRadius).indexOf('%') > -1 ? this.realStyle.borderRadius : (this.realStyle.borderRadius + 'px')
        },
        finalBoxShadow () {
            return this.realStyle.boxShadow
        },
    }
}
</script>
<style lang="less">
</style>